import { useEffect, useState } from "react";
import { DatePickerComponent } from "./DatePickerComponent";
import { DateRange } from "react-day-picker";
import { isBefore, isSameDay } from "date-fns";

export interface DateRangePickerProps {
    dateValues?: DateRange;
    dateRangeChanged: (date: DateRange | undefined) => void;
    invalid?: boolean;
    validChanged: (valid: boolean) => void,
    disablePastDates?: boolean,
}

export const DateRangePickerComponent: React.FC<DateRangePickerProps> = (props) => {
    const [invalidStartDate, setInvalidStartDate] = useState(false);
    const [invalidEndDate, setInvalidEndDate] = useState(false);
    const [fromKey, setFromKey] = useState(0);
    const [toKey, setToKey] = useState(1);

    useEffect(() => {
        setTimeout(() => {
            setFromKey((state) => state + 1);
            setToKey((state) => state + 1);
        }, 200)
    }, [])

    useEffect(() => {
        let invalidStart = invalidStartDate;
        let invalidEnd = invalidEndDate;

        if (props.dateValues?.from && props.dateValues?.to) {
            if (!isBefore(props.dateValues.from, props.dateValues.to) && !isSameDay(props.dateValues.from, props.dateValues.to)) {
                invalidStart = true;
                invalidEnd = true;
            } else {
                invalidStart = false;
                invalidEnd = false;
            }
            
        }
        setInvalidStartDate(invalidStart);
        setInvalidEndDate(invalidEnd);

        props.validChanged(!(invalidStart || invalidEnd));
    }, [props.dateValues])

    return (
        <div className="flex flex-row gap-2 w-full mb-4">
            <div className="w-1/2">
                <DatePickerComponent datesChanged={(v) => { props.dateRangeChanged(v) }} dateValues={props.dateValues} mode="range" placeholder="Alates" type="startDate" isInvalid={invalidStartDate || !!props.invalid} disablePastDates={props.disablePastDates} key={fromKey}/>
            </div>
            <div className="w-1/2">
                <DatePickerComponent datesChanged={(v) => { props.dateRangeChanged(v) }} dateValues={props.dateValues} mode="range" placeholder="Kuni" type="endDate" isInvalid={invalidEndDate || !!props.invalid} disablePastDates={props.disablePastDates} key={toKey}/>
            </div>
        </div>
    )
}